import * as PIXI from "pixi.js";
import Layers from "../layers/Layers";
import { Coord } from "../types/Interface";


export default class PencilLine extends PIXI.Graphics {
  private Layers = Layers.getInstance();
  private w: number;
  private lineColor: number;

  constructor(details?: { width?: number, lineColor?: number }) {
    super();
    this.w = details && details.width ? details.width : 5;
    this.lineColor = details && details.lineColor ? details.lineColor : 0x000000;
    this.addToLayer();
  }
  private addToLayer = () => this.Layers.Middle.addChild(this);

  draw(coordStart: Coord, coordEnd: Coord) {
    this
      .moveTo(coordStart.x, coordStart.y)
      .lineTo(coordEnd.x, coordEnd.y)
      .stroke({ width: this.w, color: this.lineColor, cap: "round" });
  }
}